import { render } from "./TicketsTableWeb.vue?vue&type=template&id=899b34fc&scoped=true&ts=true"
import script from "./TicketsTableWeb.vue?vue&type=script&lang=ts"
export * from "./TicketsTableWeb.vue?vue&type=script&lang=ts"

import "./TicketsTableWeb.vue?vue&type=style&index=0&id=899b34fc&lang=scss&scoped=true"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-899b34fc"]])

export default __exports__